import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-invoice-form',
  templateUrl: './invoice-form.component.html',
  styleUrl: './invoice-form.component.css'
})
export class InvoiceFormComponent {
  invoiceForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.invoiceForm = this.fb.group({
      invoiceNumber: ['', Validators.required],
      type: ['Partial', Validators.required],
      date: ['', Validators.required],
      amount: [0, Validators.required],
      currency: ['USD', Validators.required],
      gst: ['0', Validators.required],
      status: ['Pending', Validators.required],
      description: ['']
    });
  }

  onSubmit() {
    console.log(this.invoiceForm.value);
  }
}